import React from 'react'
import './cta.css'

const CTA = () => {
  return (
    <div className='omit__cta'>
      <div className='omit__cta-content'>
        <p>Request Our Pricing To Get Started</p>
        <h3>
          Contact us within today & start exploring the endless possiblities.
        </h3>
      </div>
      <div className='omit__cta-btn'>
        <button type='button'>Get Pricing</button>
      </div>
    </div>
  )
}

export default CTA
